import React, { useEffect } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {
  Card,
  CardContent,
  Divider,
  Grid,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import SaveIcon from "@mui/icons-material/Save";
import DonutChart from "../components/donutchart";
import { Link, Outlet, useNavigate, useOutletContext } from "react-router-dom";

export default function Dashboard(props) {
  const [title, setTitle, subTitle, setSubTitle, getDat, dat] =
    useOutletContext();

  useEffect(() => {
    setTitle("Legal Discovery");
    setSubTitle("Dashboard");
    console.log("title", title);
  }, []);

  return (
    <>
      <Outlet
        {...props}
        context={[title, setTitle, subTitle, setSubTitle, getDat, dat]}
      />
    </>
  );
}
